'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_DangerAlert$SignDocumentErrorContext(hash, kind, name, size) {
  this.JV = null;
  this.JW = null;
  this.JX = null;
  this.JY = 0.0;
  this.JV = hash;
  this.JW = kind;
  this.JX = name;
  this.JY = size;
}
export { $c_Lpresto_DangerAlert$SignDocumentErrorContext as $c_Lpresto_DangerAlert$SignDocumentErrorContext };
$p = $c_Lpresto_DangerAlert$SignDocumentErrorContext.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DangerAlert$SignDocumentErrorContext;
/** @constructor */
function $h_Lpresto_DangerAlert$SignDocumentErrorContext() {
}
export { $h_Lpresto_DangerAlert$SignDocumentErrorContext as $h_Lpresto_DangerAlert$SignDocumentErrorContext };
$h_Lpresto_DangerAlert$SignDocumentErrorContext.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("SignDocumentErrorContext"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.JV));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.JW));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.JX));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().h7(this.JY));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 4);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_DangerAlert$SignDocumentErrorContext)) {
    if (((this.JY === x$0.JY) && (this.JV === x$0.JV))) {
      var x = this.JW;
      var x$2 = x$0.JW;
      var $x_1 = (x === x$2);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.JX === x$0.JX);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 4;
});
$p.s = (function() {
  return "SignDocumentErrorContext";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.JV;
      break;
    }
    case 1: {
      return this.JW;
      break;
    }
    case 2: {
      return this.JX;
      break;
    }
    case 3: {
      return this.JY;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_DangerAlert$SignDocumentErrorContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i3)));
}
export { $isArrayOf_Lpresto_DangerAlert$SignDocumentErrorContext as $isArrayOf_Lpresto_DangerAlert$SignDocumentErrorContext };
var $d_Lpresto_DangerAlert$SignDocumentErrorContext = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DangerAlert$SignDocumentErrorContext, "presto.DangerAlert$SignDocumentErrorContext", ({
  i3: 1,
  i1: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_DangerAlert$SignDocumentErrorContext as $d_Lpresto_DangerAlert$SignDocumentErrorContext };
//# sourceMappingURL=presto.-Danger-Alert$-Sign-Document-Error-Context.js.map
